module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point3_1-c2e507bb91b39ae3aa45cac9b08b9979.jpg";